import React, { useEffect, useRef } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { ArrowForward } from '@one-thd/sui-icons';
import { PIP_QUESTIONS } from '../../MagicApronAssistant/subcomponents/constants';
import { getRandomElements } from '../../MagicApronAssistant/subcomponents/utils';
import { TileButton } from '../../MagicApronAssistant/subcomponents/TileButton';
import { waitForRefValue } from '../../../utils/common';

const randomSuggestQuestions = getRandomElements(PIP_QUESTIONS);

export const EntryPointSuggestedQuestions = () => {
  const suggestedQuestions = randomSuggestQuestions;
  const maaBroadcastChannel = useRef(null);
  const maaComponentReady = useRef({ isReady: false, resolver: null });

  useEffect(() => {
    maaBroadcastChannel.current = new BroadcastChannel('magic-apron-assistant');

    const isReadyListener = ({ output: { isReady } }) => {
      maaComponentReady.current.isReady = isReady;

      if (isReady && maaComponentReady.current.resolver) {
        maaComponentReady.current.resolver();
      }
    };

    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('magic-apron-assistant.isReady', isReadyListener);

    return () => {
      maaBroadcastChannel.current.close();
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.off('magic-apron-assistant.isReady', isReadyListener);
    };
  }, []);

  const onQuestionClick = async (question, position) => {
    maaBroadcastChannel.current.postMessage({ type: 'MAA_OPEN_DRAWER' });

    if (question) {
      const skipWait = maaComponentReady.current.isReady;
      return waitForRefValue(maaComponentReady, 'isReady', skipWait)
        .then(() => {
          window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('magic-apron-assistant.ask-question', {
            question,
            position,
          });
        })
        // eslint-disable-next-line no-console
        .catch((err) => { console.error(err); });
    }
    return Promise.resolve();
  };

  return (
    <div className="sui-flex sui-flex-row sui-flex-wrap sui-gap-4">
      {suggestedQuestions.map((question, i) => (
        <div className="sui-flex" key={i}>
          <TileButton
            onClick={() => onQuestionClick(question, i)}
            value={question}
            data-testid="suggested-question"
            lineClamp={2}
            withIcon
          />
        </div>
      ))}
      <div className="sui-flex sui-shrink-0" key="ask-prompt">
        <div className="sui-bg-primary">
          <Button variant="secondary" onClick={() => onQuestionClick()}>
            <div className="sui-flex sui-items-center sui-gap-2">
              Ask a Question  <ArrowForward size="small" />
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};
